import { ReactNode, useMemo } from "react";
import { createFastContext } from "../../contexts/createFastContext";
import { cloneObj } from "../../util/varibles/global";
import { IChecklist } from "../../util/varibles/interface";

interface IState {
    data?: IChecklist
    result: { [id: string]: any }
    disabled?: boolean
    vesselTenantId?: string
    error?: { [id: string]: string }

    onResultChange?(value: any): void
}

const {
    Provider,
    useStore: useChecklist,
    setStore: setChecklist,
    getStore: getChecklist,
    callEvent: callEventChecklist
} = createFastContext<IState, {
    onResultChange(value: any): void
}>({
    result: {},
    error: {}
});

const ChecklistProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    const currentValue = args.data?.result;
    const result = useMemo(() => {
        try {
            if (typeof currentValue === "object") return currentValue;
            return JSON.parse(currentValue || JSON.stringify({}));
        } catch (e) {
            console.log('JSON error:', e)
            return {};
        }
    }, [currentValue]);

    return <Provider props={{ ...args, result }} event={{
        onResultChange(value: any, { get, set }) {
            const { result: old, error } = get();
            const newResult = { ...old, ...value };
            const cloneError = cloneObj(error || {});
            Object.keys(value).forEach(key => {
                if (cloneError?.[key] && value[key]) delete cloneError[key]
            })
            args.onResultChange?.(newResult);
            set({ result: newResult, error: cloneError })
        }
    }}>
        {children}
    </Provider>
}


export { callEventChecklist, ChecklistProvider, getChecklist, setChecklist, useChecklist };
